export default "__VITE_ASSET__DglzZ1be__"